export default "__VITE_ASSET__e3d68cf1__"